<div class="login-page">
  <div class="background-login">
    <div class="shape">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1440 120"
      >
        <path
          d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"
        ></path>
      </svg>
    </div>
  </div>
  <div id="login" class="pb-5">
    <div class="login">
      <form
        *ngIf="!sendEmail"
        (ngSubmit)="sendCode()"
        [formGroup]="emailForm"
        class="login-form p-5"
      >
        <div class="form-group">
          <div class="logo-entity mb-3 text-center">
            <img src="{{ entityLogo }}" width="60" />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>{{ "t-enter-email" | translate }}</label>
          <input
            type="email"
            formControlName="email"
            [ngClass]="{
              'is-invalid': submited && formEmail['email'].errors
            }"
            class="form-control"
            name="email"
            id="email"
          />
          <div
            *ngIf="submited && formEmail['email'].errors"
            class="invalid-feedback"
          >
            <div *ngIf="formEmail['email'].errors['required']">
              {{ "t-validation-email" | translate }}
            </div>
            <div *ngIf="formEmail['email'].errors['email']">
              {{ "t-validation-email-2" | translate }}
            </div>
            <div *ngIf="formEmail['email'].errors['incorrectEmail']">
              Insira o seu e-mail corretamente
            </div>
          </div>
          <i class="icon_mail_alt"></i>
        </div>
        <button
          class="btn white w-100 submit-button"
          type="submit"
          [attr.disabled]="isDisabled ? '' : null"
        >
          <span *ngIf="!isDisabled">{{ "t-continue" | translate }}</span>
          <span class="d-flex justify-content-center" *ngIf="isDisabled">
            <span class="me-2"> {{ "t-continue" | translate }}... </span>
            <span class="spinner-border flex-shrink-0" role="status">
              <span class="visually-hidden">
                {{ "t-continue" | translate }}...</span
              >
            </span>
          </span>
        </button>
      </form>
      <form
        *ngIf="sendEmail"
        [formGroup]="changePassForm"
        (ngSubmit)="changePass()"
        class="login-form p-5"
      >
        <div class="form-group mb-2 text-center">
          <div class="logo-entity mb-3 text-center">
            <img src="{{ entityLogo }}" width="60" />
          </div>
          <span *ngIf="!currentUser">{{
            "t-change-pass-text" | translate
          }}</span>
        </div>
        <div *ngIf="currentUser" class="form-group">
          <label>{{ "t-old-password" | translate }}</label>
          <input
            type="password"
            formControlName="oldPass"
            [ngClass]="{
              'is-invalid': submited && form['oldPass'].errors
            }"
            class="form-control"
            name="oldPass"
            id="oldPass"
          />
          <div
            *ngIf="submited && form['oldPass'].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form['oldPass'].errors['required']">
              {{ "t-validation-password" | translate }}
            </div>
            <div *ngIf="form['oldPass'].errors['invalidCredentials']">
              {{ "t-wrong-credentials" | translate }}
            </div>
          </div>
          <i class="icon_mail_alt"></i>
        </div>
        <div class="form-group">
          <label>{{ "t-new-password" | translate }}</label>
          <input
            type="password"
            formControlName="password"
            [ngClass]="{
              'is-invalid': submited && form['password'].errors
            }"
            class="form-control"
            name="password"
            id="password"
          />
          <div
            *ngIf="submited && form['password'].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form['password'].errors['required']">
              {{ "t-new-password-validation" | translate }}
            </div>
          </div>
          <i class="icon_mail_alt"></i>
        </div>
        <div [ngClass]="{ 'mb-3': currentUser }" class="form-group">
          <label>{{ "t-confirm-password" | translate }}</label>
          <input
            type="password"
            [ngClass]="{
              'is-invalid': submited && form['confirmPassword'].errors
            }"
            formControlName="confirmPassword"
            class="form-control"
            name="confirmPassword"
            id="confirmPassword"
            value=""
          />
          <div
            *ngIf="submited && form['confirmPassword'].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form['confirmPassword'].errors['required']">
              {{ "t-validation-confirm-password" | translate }}
            </div>
            <div *ngIf="form['confirmPassword'].errors['diferentPass']">
              {{ "t-validation-confirm-password-2" | translate }}
            </div>
          </div>
          <i class="icon_lock_alt"></i>
        </div>
        <div *ngIf="!currentUser" class="form-group mb-3">
          <label>{{ "t-code" | translate }}</label>
          <input
            type="text"
            [ngClass]="{
              'is-invalid': submited && form['confirmCode'].errors
            }"
            formControlName="confirmCode"
            class="form-control"
            name="confirmCode"
            id="confirmCode"
            value=""
          />
          <div
            *ngIf="submited && form['confirmCode'].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form['confirmCode'].errors['required']">
              {{ "t-code-validation" | translate }}
            </div>
            <div *ngIf="form['confirmCode'].errors['incorrectCode']">
              {{ "t-code-validation-error" | translate }}
            </div>
          </div>
          <i class="icon_lock_alt"></i>
        </div>
        <button
          class="btn white w-100 submit-button"
          type="submit"
          [attr.disabled]="isDisabled ? '' : null"
        >
          <span *ngIf="!isDisabled">{{ "t-continue" | translate }}</span>
          <span class="d-flex justify-content-center" *ngIf="isDisabled">
            <span class="me-2"> {{ "t-continue" | translate }}... </span>
            <span class="spinner-border flex-shrink-0" role="status">
              <span class="visually-hidden">
                {{ "t-continue" | translate }}...</span
              >
            </span>
          </span>
        </button>
      </form>
    </div>
  </div>
</div>
